/** Item da carga que o Recharts entrega ao conteúdo customizado do tooltip. */
interface ChartTooltipPayloadItem {
  readonly value?: number | string;
}

export interface ChartTooltipProps {
  /** Rótulo da série exibido acima do valor. */
  readonly seriesLabel: string;
  /** Formatador do valor do ponto. */
  readonly formatValue: (value: number) => string;
  /** Formatador do rótulo do eixo X (a data do ponto). */
  readonly formatLabel: (label: string) => string;
  /** Injetado pelo Recharts — verdadeiro quando o cursor está sobre um ponto. */
  readonly active?: boolean;
  /** Injetado pelo Recharts. */
  readonly payload?: readonly ChartTooltipPayloadItem[];
  /** Injetado pelo Recharts — valor do eixo X do ponto sob o cursor. */
  readonly label?: string | number;
}

/**
 * Tooltip customizado dos gráficos do dashboard.
 *
 * Existe para que o balão use os tokens de superfície e tipografia do design system em
 * vez do estilo inline default do Recharts.
 */
export function ChartTooltip({
  seriesLabel,
  formatValue,
  formatLabel,
  active,
  payload,
  label,
}: ChartTooltipProps) {
  const rawValue = payload?.[0]?.value;

  if (!active || rawValue === undefined) return null;

  const numericValue = typeof rawValue === 'number' ? rawValue : Number(rawValue);

  return (
    <div className="flex flex-col gap-quark rounded-sm border-hairline border-ctx-layout-border bg-ctx-layout-surface px-micro py-nano shadow-level2">
      <span className="text-ctx-content-placeholder ts-caption-xxs">
        {formatLabel(String(label ?? ''))}
      </span>
      <span className="text-ctx-content-title ts-heading-xxs tabular-nums">
        {seriesLabel}: {Number.isNaN(numericValue) ? '—' : formatValue(numericValue)}
      </span>
    </div>
  );
}
